import { RentTypeModel } from "./rent-type.model"

export class TariffModel {
  id!: number
  capacity!: number
  capacityDisplay!: TariffCapacityDisplay
  reservationMode!: TariffReservationMode
  occupied!: number
  free!: number
  priceHourly!: number
  priceDaily!: number
  priceMonthly?: number
  tariffType!: TariffTypeModel
  tariffTypeId!: number
  rentType!: RentTypeModel
  rentTypeId!: number
  uuid!: string
}

export enum TariffReservationMode {
  ALL = "all",
  NONE = "none",
}

export enum TariffCapacityDisplay {
  HIDDEN = "hidden",
  BINARY = "binary",
  FULL = "full",
}

export class TariffTypeModel {
  id!: number
  name!: string
  description!: string
  icon!: string
  serviceProvider!: string
}
